namespace $ {

	$mol_style_define( $shm_hitalama_codex_map, {
		Chat_page: {
			width: '27rem',
			minWidth: '24rem',
			flex: { basis: '27rem', grow: 0, shrink: 0 },
			margin: { left: 'auto' },
		},
		'@media': {
			'(max-width: 640px)': {
				Chat_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
					margin: 0,
				},
			},
		},
	} )

}
